type Props = {
	stroke?: string
}

export const ArrowUpRightIcon = ({ stroke = "currentColor" }: Props) => {
	return (
		<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.26823 7.26725V0.600586H0.601562M7.26823 0.600586L0.601562 7.26725"
				stroke={stroke}
				strokeWidth="1.2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
